@let blok = block();
@for (child of blok.children; track child['_uid']) {
  <s1-cms-component [blok]="child"/>
}
@for (child of blok.children2; track child['_uid']) {
  <s1-cms-component [blok]="child"  [ngClass]="getTextClasses()"/>
}
